const ignoreValues = [null, undefined, ''];

// immutable has a get, but I think it's not available in our version
const get = (object, key) => (object.get ? object.get(key) : object[key]);

export default function (params) {
  const queryString = (params.keySeq ? params.keySeq() : Object.keys(params))
    .filter(key => ignoreValues.every(v => v !== get(params, key)))
    .map(key => key + '=' + get(params, key))
    .join('&');
  return queryString.length === 0 ? '' : '?' + queryString;
}
